module.exports = __webpack_public_path__ + "img/mi-logotype.5bb17307.png";